

















    import Vue from 'vue';
    import { Component } from 'vue-property-decorator';
    import { VFields } from '@/models/v-fields';
    import { Team } from '@/models/admin/team';
    import { Base } from '@/components/common/base';
    import {teamService} from '@/shared';
import { ValidationRules } from '@/helper/enum';

    @Component({
        props: ['methodName', 'progress'],
        computed: {
            methodtoCall: {
                get() {
                    return this.$props.methodName;
                },
            },
        },
    })
    export default class TeamSavePage extends Base {
        public team: Team = {
            id: '0',
            name: '',
            users: [],
            selected: false,
        };
        public form: any = {};
        public formFields: Array<VFields<any>> = [];
        public tenantId: number = 0;
        public enterpriseId: number = 0;
        public storeId: number = 0;
        public disableSubmitButton: boolean = false;

        public beforeDestroy() {
            const buttons = [];
            this.$emit('updateToolBar', buttons);
        }
        public callMethod(methodName): void {
            if (methodName === 'backToList') {
                this.$router.push({ name: 'admin.teams', params: { storeId: this.storeId.toString() } });
            } else if (methodName === 'submit') {
                if (!this.form.$valid) {
                    this.showAlert(false, 'Form is Invalid!');
                    this.resetMethodName(methodName);
                    return;
                }
                this.submitTeam();
            }
            this.resetMethodName(methodName);
        }
        public resetMethodName(methodName): void {
            if (methodName !== '') {
                this.$emit('resetMethodName', methodName);
            }
        }
        public updateToolBar(): void {
            const buttons: any = [];
            buttons.push({ id: '0', type: 'button', title: this.$parent.$t('teams.btnBack'), disabled: false, visible: true, class: 'btn', label: this.$parent.$t('teams.btnBack'), click: 'backToList', icon: 'fas fa-arrow-left' });
            this.$emit('updateToolBar', buttons);
        }
        public async mounted(): Promise<void> {
            // activating tab
            this.$root.$emit('sidebar.layout.vue', 'teams');

            this.storeId = Number(this.$route.params.storeId);

            // Toolbar
            this.updateToolBar();
            this.$watch('methodtoCall', (newVal, oldVal) => {
                if (newVal) {
                    this.callMethod(newVal);
                }
            });

            this.formFields = [{
                key: 'name',
                type: 'v-alynk-text-field',
                required: true,
                templateOptions: {
                    counter: 50,
                    label: this.$t('teams.teamFields.name') as string,
                    required: true,
                    disabled: false,
                    loading: false,
                    rules:[
                        v => this.required('Name', v)
                    ]
                },
            }];

            if (this.$route.params.id) {
                try {
                    this.formlyShowSkeleton(this.formFields);
                    const response = await teamService.getTeam(this.$route.params.id, this.storeId);
                    this.team = response;
                } finally {
                    this.formlyHideSkeleton(this.formFields);
                }
            }
        }

        public validateTeam(): Vue & { validate: () => boolean } {
            return this.$refs.teamForm as Vue & { validate: () => boolean };
        }

        public async submitTeam(): Promise<void> {
            if(this.validateTeam().validate()){
                try {
                    this.disableSubmitButton = true;
                    this.$emit('update:progress', this.disableSubmitButton);
                    if (this.$route.params.id) {
                        await teamService.updateTeam(this.$route.params.id, this.storeId, this.team);
                        this.showAlert(true, this.$t('teams.alertUpdateTeam'));
                        this.$router.push({ name: 'admin.teams', params: { storeId: this.storeId.toString() } });
                    } else {
                        await teamService.saveTeam(this.storeId, this.team);
                        this.showAlert(true, this.$t('teams.alertSaveTeam'));
                        this.$router.push({ name: 'admin.teams', params: { storeId: this.storeId.toString() } });
                    }
                } finally {
                    this.disableSubmitButton = false;
                    this.$emit('update:progress', this.disableSubmitButton);
                }
            }
        }
    }
